import React from 'react'

import LeaseTerm from 'components/config/quote/LeaseTerm'
import LoanTerm from 'components/config/quote/LoanTerm'
import Down from 'components/config/quote/Down'
import CreditTier from 'components/config/quote/CreditTier'
import Mileage from 'components/config/quote/Mileage'

import sortBy from 'lodash/sortBy'

export function getSections({ editValue }) {
  return {
    leaseTerms: {
      title: 'Available Lease Terms',
      headers: ['Term Label (ex. 24mo.)', 'Term Value (ex. 24)'],
      sort: vals => sortBy(vals, 'value'),
      starter: {
        label: '',
        value: '',
        default: false,
      },
      valueSelectorLabel: (
        <span>
          How many <strong>Months</strong> do you want to drive this car? (Lease
          Only)
        </span>
      ),
      renderer: s => (item, index, items) => (
        <LeaseTerm {...{ item, index, items }} editValue={editValue(s)} />
      ),
    },
    loanTerms: {
      title: 'Available Loan Terms',
      headers: ['Term Label (ex. 24mo.)', 'Term Value (ex. 24)'],
      sort: vals => sortBy(vals, 'value'),
      starter: {
        label: '',
        value: '',
        default: false,
      },
      valueSelectorLabel: (
        <span>
          How many <strong>Months</strong> do you want to drive this car? (Loan
          Only)
        </span>
      ),
      renderer: s => (item, index, items) => (
        <LoanTerm {...{ item, index, items }} editValue={editValue(s)} />
      ),
    },
    downs: {
      title: 'Available Money Down',
      headers: [
        'Down Option Label (ex. $1,000)',
        'Down Option Value (ex. 1000)',
      ],
      sort: vals => sortBy(vals, 'value'),
      starter: {
        label: '',
        value: '',
        default: false,
      },
      valueSelectorLabel: (
        <span>
          How much can you <strong>Put Down</strong>?
        </span>
      ),
      renderer: s => (item, index, items) => (
        <Down {...{ item, index, items }} editValue={editValue(s)} />
      ),
    },
    creditTiers: {
      title: 'Available Credit Tiers',
      headers: [
        'Credit Tier Label (ex. Good)',
        'Credit Score Cutoff (ex. 700)',
      ],
      starter: {
        label: '',
        value: '',
        default: false,
      },
      valueSelectorLabel: (
        <span>
          How is your <strong>Credit</strong>?
        </span>
      ),
      renderer: s => (item, index, items) => (
        <CreditTier {...{ item, index, items }} editValue={editValue(s)} />
      ),
    },
    mileages: {
      title: 'Available Miles per Year',
      sort: vals => sortBy(vals, 'value'),
      headers: [
        'Mileage Option Label (ex. 12k)',
        'Mileage Option Value (e. 12000',
      ],
      starter: {
        label: '',
        value: '',
        default: false,
      },
      valueSelectorLabel: (
        <span>
          How many <strong>Miles Per Year</strong> do you drive?
        </span>
      ),
      renderer: s => (item, index, items) => (
        <Mileage {...{ item, index, items }} editValue={editValue(s)} />
      ),
    },
  }
}

export default getSections
